import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../lib/api.ts';
import { useStore } from '../lib/store.ts';
import type { TrainingPlanRequest } from '../types/api.ts';

export function useTrainingPlan() {
  const { t } = useTranslation();
  const addToast = useStore((s) => s.addToast);

  return useMutation({
    mutationFn: (data: TrainingPlanRequest) => api.trainingPlan(data),
    onError: () => addToast({ message: t('errors.trainingPlanFailed'), type: 'error' }),
  });
}
